import { render, staticRenderFns } from "./CertificatesAdmin.vue?vue&type=template&id=3fff71b2&"
import script from "./CertificatesAdmin.vue?vue&type=script&lang=js&"
export * from "./CertificatesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports